class SearchForm extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.setupListeners()
  }

  setupListeners () {
    this.handleSearchInput = this.handleSearchInput.bind(this)
    this.handleBodyClick = this.handleBodyClick.bind(this)

    this.listeners.add(this.els.input.element, 'click', this.handleSearchInput)

    if (this.els.close) {
      this.listeners.add(this.els.close.element, 'click', this.closeSearch)
    }

    document.body.addEventListener('click', this.handleAddToCartClick)
    document.body.addEventListener('click', this.handleBodyClick)
  }

  handleSearchInput (event) {
    event.stopPropagation()
    document.body.classList.add('util-SiteOverflowed', 'util-Search-open')

    window.setTimeout(() => {
      this.externalEls.klevu.element.focus()
    }, 500)
  }

  handleBodyClick (event) {
    if (
      !this.els.input.elements.includes(event.target) &&
      !event.target.closest('.klevuWrap')
    ) {
      this.closeSearch()
    }
  }

  closeSearch () {
    if (!document.body.classList.contains('util-Search-open')) return

    document.body.classList.remove('util-SiteOverflowed', 'util-Search-open')
  }
}

if (!customElements.get('search-form')) {
  customElements.define('search-form', SearchForm)
}
